import styles from "./EMIDetails.module.scss";

export default function EMIDetails({emiData}) {
  return (
    <div>
      <div className={styles.emiBreakdown}>
        <div className={styles.title}>
          <div className={styles.dateColumnSize}>EMI Dates</div>
          <div>Principal</div>
          <div>Interest</div>
          <div>Amount</div>
        </div>

        {emiData.map((item, index) => (
          <div className={styles.emiContainer} key={index}>
            <div className={styles.repayDate}>
              <span className={styles.index}>{index + 1}</span>
              <div className={styles.date}>
                {new Date(item.dueDate).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </div>
            </div>
            <div className="principal column">₹{item?.principal.toLocaleString("en-IN")}</div>
            <div className="interest column">₹{item?.interest.toLocaleString("en-IN")}</div>
            <div className="emi column">₹{item?.emi.toLocaleString("en-IN")}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
